import avatar from "assets/img/avatars/avatar4.png";
import Dropdown from "components/dropdown";
import React from "react";
import { RiMoonFill, RiSunFill } from "react-icons/ri";
import { Link, useNavigate } from "react-router-dom";
import useStore from "store/store";

const Navbar = (props) => {
  const { brandText } = props;
  const [darkmode, setDarkmode] = React.useState(false);
  const navigate = useNavigate();
  const setIsAuth = useStore((state) => state.setIsAuth);

  const handleLogout = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/users/logout-cms`,
        {
          method: "POST",
          credentials: "include",
        }
      );

      if (!response.ok) {
        throw new Error("Logout failed");
      }

      setIsAuth(null);
      navigate("/auth");
    } catch (error) {
      console.error("Error logging out:", error);
    }
  };

  return (
    <nav className="flex w-full items-center justify-between border-b border-gray-200 bg-white/95 p-3 shadow-[0_4px_6px_-1px_rgba(0,0,0,0.1)] backdrop-blur-xl dark:border-gray-800 dark:!bg-navy-900">
      <div className="ml-[6px]">
        <p className="text-gradient shrink text-[28px] font-semibold capitalize">
          <Link
            to="#"
            className="capitalize hover:text-primary dark:hover:text-white"
          >
            {brandText}
          </Link>
        </p>
      </div>

      <div className="relative flex items-center gap-4">
        {/* Dark Mode Toggle */}
        <div
          className="cursor-pointer rounded-full bg-gray-100 p-2 transition-all duration-200 hover:bg-gray-200 dark:bg-navy-700 dark:hover:bg-navy-800"
          onClick={() => {
            if (darkmode) {
              document.body.classList.remove("dark");
              setDarkmode(false);
            } else {
              document.body.classList.add("dark");
              setDarkmode(true);
            }
          }}
        >
          {darkmode ? (
            <RiSunFill className="h-5 w-5 text-primary dark:text-white" />
          ) : (
            <RiMoonFill className="h-5 w-5 text-primary dark:text-white" />
          )}
        </div>

        {/* Profile & Dropdown */}
        <Dropdown
          button={
            <div className="h-10 w-10 overflow-hidden rounded-full border-2 border-primary">
              <img
                className="h-full w-full object-cover"
                src={avatar}
                alt="Admin"
              />
            </div>
          }
          children={
            <div className="flex w-56 flex-col justify-start rounded-[20px] bg-white bg-cover bg-no-repeat shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:text-white dark:shadow-none">
              <div className="p-4">
                <div className="flex items-center gap-2">
                  <p className="text-sm font-bold text-primary dark:text-white">
                    👋 Hey, Admin
                  </p>
                </div>
              </div>
              <div className="h-px w-full bg-gray-200 dark:bg-white/20 " />

              <div className="flex flex-col p-4">
                <a
                  href=" "
                  className="text-sm text-gray-800 transition-colors duration-200 hover:text-primary dark:text-white hover:dark:text-primary"
                >
                  Profile Settings
                </a>
                <a
                  href=" "
                  className="mt-3 text-sm font-medium text-red-500 transition duration-150 ease-out hover:text-red-600 hover:ease-in"
                  onClick={handleLogout}
                >
                  Log Out
                </a>
              </div>
            </div>
          }
          classNames={"py-2 top-8 -left-[180px] w-max"}
        />
      </div>
    </nav>
  );
};

export default Navbar;
